function deUmlaut(value) {
  value = value.toLowerCase()
  value = value.replace(/å/g, 'a')
  value = value.replace(/ä/g, 'a')
  value = value.replace(/ö/g, 'o')
  value = value.replace(/ü/g, 'ue')
  value = value.replace(/ß/g, 'ss')
  return value
}

export function transformTitleToId(text) {
  return deUmlaut(text.toLowerCase().replace(/\s+/g, '-'))
}

export function cleanString(text) {
  const regex = /(<([^>]+)>)/gi;
  const result = text.replace(regex, "");

  return result;
}
